import { Typography, Box, IconButton } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import CloseIcon from "@mui/icons-material/Close";

const PaymentSuccessBanner = ({ onClose }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        backgroundColor: PureLightThemeCaaS.colors.alpha.orange[100],
        color: PureLightThemeCaaS.colors.alpha.white[100],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "8px 16px",
        marginTop: "70px",
        minHeight: "70px",
        zIndex: 9999,
      }}
    >
      <Box sx={{ flex: 1, textAlign: "center" }}>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Roboto, Arial",
            fontWeight: 500,
          }}
        >
          You have successfully upgraded to a paid RotoGPT Developer Account!
        </Typography>
      </Box>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          color: PureLightThemeCaaS.colors.alpha.white[100],
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default PaymentSuccessBanner;
